export default {
  contracts: {
    results: [],
  },
  oneContract: {},
  checkedMaterialIds: [],
  checkedInstrumentIds: [],
  checkedMaterialIdsForEdit: [],
  checkedInstrumentIdsForEdit: [],
  materialItems: [],
  materialItemsForEdit: [],
  instrumentItems: [],
  instrumentItemsForEdit: [],
  invoiceItems: [],
  invoice_id: '',
  contract_id: '',
  materialAndInstrumentApplications: [],
  materialAndInstrumentApplicationsForEdit: [],
  viewMode: false,
  addContractInvoiceType: false,
  addNewContractInvoice: true,


  contract: {
    type_contract: true,
    contract_number: null,
    seller: null,
    goods: [],
    instrument: [],
    date: null,
    total_sum: null,
  },


  files: [],
  contractFiles: [],
  refreshAgreement: false
}
